'use client';

import { useEffect } from 'react';

import { authentication } from '@microsoft/teams-js';
import { useSearchParams } from 'next/navigation';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import { signIn, useSession } from 'next-auth/react';

import { useStore } from '../state/store-provider';
import { deleteCookie, helpHubStoreCookieName } from '../utils/cookies';
import { useTeamsContext } from '../utils/teams-context';
import { refreshAccessTokenError } from './refresh-token';

export const AccessTokenChecker = () => {
  const { data: session, status } = useSession();
  const searchParams = useSearchParams();
  const callbackUrl = searchParams?.get('callbackUrl') ?? '/';
  const { isInTeams, isInitialized } = useTeamsContext();

  const [draftIssueReset, locationReset] = useStore(
    ({ draftIssue, location }) => [draftIssue.reset, location.reset]
  );

  useEffect(() => {
    if (!isInitialized) {
      return;
    }

    if (session?.error === refreshAccessTokenError) {
      if (isInTeams) {
        // Silent re-acquisition via Teams SDK + NextAuth CredentialsProvider
        const reAuth = async () => {
          /* eslint-disable-next-line functional/no-try-statement */
          try {
            const teamsToken = await authentication.getAuthToken();
            await signIn('teams', { teamsToken, redirect: false });
          } catch {
            // Token re-acquisition failed silently; session will retry on next render
          }
        };

        void reAuth();
      } else {
        void signIn('azure-ad', {
          callbackUrl,
        }); // Force sign in to obtain a new set of access and refresh tokens
      }
    }
  }, [session?.error, callbackUrl, isInTeams, isInitialized]);

  useEffect(() => {
    if (status === 'unauthenticated') {
      draftIssueReset();
      locationReset();
      deleteCookie(helpHubStoreCookieName);
      return;
    }
  }, [status, draftIssueReset, locationReset]);

  return null;
};
